//accordion bs5
document.addEventListener('DOMContentLoaded', function() {
  const accordionButtons = document.querySelectorAll('.accordion-button');
  
  accordionButtons.forEach((button) => {
    button.addEventListener('click', function() {
      const accordionItem = this.closest('.accordion-item');
      const accordionCollapse = accordionItem ? accordionItem.querySelector('.accordion-collapse') : null;

      if (accordionCollapse) {
        // Toggle the 'show' class for the accordion body
        if (accordionCollapse.classList.contains('show')) {
          accordionCollapse.classList.remove('show');
          this.classList.add('collapsed'); // Add collapsed class to button
        } else {
          // Close other open panels
          // const openPanels = document.querySelectorAll('.accordion-collapse.show');
          // openPanels.forEach(panel => {
          //   panel.classList.remove('show');
          //   const correspondingButton = panel.closest('.accordion-item').querySelector('.accordion-button');
          //   correspondingButton.classList.add('collapsed'); // Set other buttons as collapsed
          // });

          // Open the clicked panel
          accordionCollapse.classList.add('show');
          this.classList.remove('collapsed'); // Remove collapsed class from the clicked button
        }
      }
    });
  });
});